const types = {
  //Get Lead Customer List
  GET_LEAD_CUSTOMER_START: "GET_LEAD_CUSTOMER_START",
  GET_LEAD_CUSTOMER_SUCCESS: "GET_LEAD_CUSTOMER_SUCCESS",
  GET_LEAD_CUSTOMER_ERROR: "GET_LEAD_CUSTOMER_ERROR",
  GET_LEAD_CUSTOMER_RESET: "GET_LEAD_CUSTOMER_RESET",

  //Create Lead Customer
  CREATE_LEAD_CUSTOMER_START: "CREATE_LEAD_CUSTOMER_START",
  CREATE_LEAD_CUSTOMER_SUCCESS: "CREATE_LEAD_CUSTOMER_SUCCESS",
  CREATE_LEAD_CUSTOMER_ERROR: "CREATE_LEAD_CUSTOMER_ERROR",
  CREATE_LEAD_CUSTOMER_RESET: "CREATE_LEAD_CUSTOMER_RESET",

  //Update Lead Customer
  UPDATE_LEAD_CUSTOMER_START: "UPDATE_LEAD_CUSTOMER_START",
  UPDATE_LEAD_CUSTOMER_SUCCESS: "UPDATE_LEAD_CUSTOMER_SUCCESS",
  UPDATE_LEAD_CUSTOMER_ERROR: "UPDATE_LEAD_CUSTOMER_ERROR",
  UPDATE_LEAD_CUSTOMER_RESET: "UPDATE_LEAD_CUSTOMER_RESET",

  //Delete Lead Customer
  DELETE_LEAD_CUSTOMER_START: "DELETE_LEAD_CUSTOMER_START",
  DELETE_LEAD_CUSTOMER_SUCCESS: "DELETE_LEAD_CUSTOMER_SUCCESS",
  DELETE_LEAD_CUSTOMER_ERROR: "DELETE_LEAD_CUSTOMER_ERROR",
  DELETE_LEAD_CUSTOMER_RESET: "DELETE_LEAD_CUSTOMER_RESET",

  //Single Lead Customer
  SINGLE_LEAD_CUSTOMER_START: "SINGLE_LEAD_CUSTOMER_START",
  SINGLE_LEAD_CUSTOMER_SUCCESS: "SINGLE_LEAD_CUSTOMER_SUCCESS",
  SINGLE_LEAD_CUSTOMER_ERROR: "SINGLE_LEAD_CUSTOMER_ERROR",
  SINGLE_LEAD_CUSTOMER_RESET: "SINGLE_LEAD_CUSTOMER_RESET",
};

export default types;

